import { render, staticRenderFns } from "./ReadingCreateDialog.vue?vue&type=template&id=7bf45aae&scoped=true"
import script from "./ReadingCreateDialog.vue?vue&type=script&lang=ts"
export * from "./ReadingCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf45aae",
  null
  
)

export default component.exports